<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-tabs v-model="tab" background-color="transparent" color="primary">
          <v-tab>Dashboard</v-tab>
          <v-tab v-if="canImportObjetivos">Objetivos cargados</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card class="mb-6">
              <v-card-title>Dashboard de objetivos por agencia</v-card-title>
              <v-card-text>
                <agencia-combobox
                    v-model="agenciaId"
                    label="Agencia"
                    clearable
                />
                <caja-mensual-objetivo-combobox
                    v-model="cajaMensualId"
                    class="mt-4"
                    clearable
                />
              </v-card-text>
            </v-card>

            <agencia-objetivo-dashboard
                v-if="dashboardReady"
                :agencia-id="dashboardAgenciaId"
                :caja-mensual-id="cajaMensualId"
            />

            <v-alert v-else dense type="info">
              {{ dashboardEmptyMessage }}
            </v-alert>
          </v-tab-item>

          <v-tab-item v-if="canImportObjetivos">
            <v-card class="mb-6">
              <v-card-title>Objetivos cargados</v-card-title>
              <v-card-text>
                <caja-mensual-objetivo-combobox
                    v-model="objetivosCajaMensualId"
                    clearable
                />
                <agencia-combobox
                    v-model="objetivosAgenciaId"
                    class="mt-4"
                    label="Agencia"
                    clearable
                />
              </v-card-text>
            </v-card>

            <v-alert v-if="objetivosError" dense type="error">
              {{ objetivosError }}
            </v-alert>

            <v-data-table
                :headers="objetivosHeaders"
                :items="objetivos"
                :loading="loadingObjetivos"
                :items-per-page="25"
                class="elevation-1"
            >
              <template v-slot:item.objetivo="{ item }">
                {{ formatMoney(item.objetivo) }}
              </template>
              <template v-slot:item.updatedAt="{ item }">
                {{ formatDate(item.updatedAt) }}
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import dayjs from "dayjs";
import AgenciaCombobox from "@/modules/cobrox/combobox/AgenciaCombobox/AgenciaCombobox";
import AgenciaObjetivoDashboard from "@/modules/cobrox/components/AgenciaObjetivoDashboard/AgenciaObjetivoDashboard";
import CajaMensualObjetivoCombobox from "@/modules/cobrox/combobox/CajaMensualObjetivoCombobox/CajaMensualObjetivoCombobox";
import AgenciaObjetivoProvider from "@/modules/cobrox/providers/AgenciaObjetivoProvider";

const parseBackendDate = value => {
  const raw = String(value || '')
  return /^-?\d+$/.test(raw) ? Number(raw) : value
}

export default {
  name: "AgenciaObjetivoDashboardAdminPage",
  components: {CajaMensualObjetivoCombobox, AgenciaObjetivoDashboard, AgenciaCombobox},
  data() {
    return {
      tab: 0,
      agenciaId: null,
      cajaMensualId: null,
      objetivosCajaMensualId: null,
      objetivosAgenciaId: null,
      objetivos: [],
      loadingObjetivos: false,
      objetivosError: null,
      objetivosHeaders: [
        {text: 'Agencia', value: 'agencia.nombre'},
        {text: 'Compra/Cartera', value: 'compra.nombre'},
        {text: 'Objetivo', value: 'objetivo', align: 'right'},
        {text: 'Actualizado', value: 'updatedAt'},
      ]
    }
  },
  watch: {
    objetivosCajaMensualId() {
      this.fetchObjetivos()
    },
    objetivosAgenciaId() {
      this.fetchObjetivos()
    }
  },
  computed: {
    canImportObjetivos() {
      return this.$store.getters.hasPermission('AGENCIAOBJETIVO_IMPORT')
    },
    dashboardAgenciaId() {
      return this.agenciaId
    },
    dashboardReady() {
      return this.cajaMensualId && this.agenciaId
    },
    dashboardEmptyMessage() {
      return 'Seleccione una agencia y una caja mensual para ver el dashboard.'
    }
  },
  methods: {
    fetchObjetivos() {
      if (!this.objetivosCajaMensualId) {
        this.objetivos = []
        return
      }

      this.loadingObjetivos = true
      this.objetivosError = null
      AgenciaObjetivoProvider.agenciaObjetivosPorCaja(this.objetivosCajaMensualId, this.objetivosAgenciaId)
          .then(r => {
            this.objetivos = r.data.agenciaObjetivosPorCaja || []
          })
          .catch(e => {
            this.objetivosError = e.message
          })
          .finally(() => {
            this.loadingObjetivos = false
          })
    },
    formatMoney(value) {
      return '$' + Number(value || 0).toLocaleString('es-AR')
    },
    formatDate(value) {
      return value ? dayjs(parseBackendDate(value)).format('DD/MM/YYYY HH:mm') : ''
    }
  }
}
</script>
